/**
 * Configures Amplify as a side-effect import.
 * This module must be imported before any module that transitively imports apiClient,
 * because generateClient() requires Amplify to be configured at call time.
 */
import { Amplify } from 'aws-amplify';
import AmplifyConfig from './amplify-config.ts';

Amplify.configure(AmplifyConfig);
